<template>
  <div class="login">
    <div class="login__information">
      <div class="login__information__row">
        <h1>
          <b>We Are The</b>
        </h1>
        <img
          src="https://shipwithglt.com/wp-content/uploads/2018/09/DOS-FLECHAS.svg"
          width="15%"
          height="15%"
        />
      </div>
      <h1>
        <b>Experts You Need</b>
      </h1>
    </div>
    <div class="login__content">
      <div class="login__content__form">
        <img class="login__content__form--logo" src="../../assets/images/glt-logo.png" />
        <div class="login__content__form__submit">
          <p class="login__content__form__submit--hint">
            Sign in with your corporate Microsoft account
          </p>
        </div>

        <div class="login__content__form__submit__options">
          <b-overlay :show="isLoading" rounded opacity="0.6" spinner-small>
            <!-- Microsoft branded sign-in button -->
            <button
              type="button"
              :disabled="isLoading"
              class="ms-button"
              @click="login()"
            >
              <svg class="ms-button__logo" viewBox="0 0 21 21" aria-hidden="true">
                <rect x="0" y="0" width="9.5" height="9.5" fill="#f25022" />
                <rect x="11.5" y="0" width="9.5" height="9.5" fill="#7fba00" />
                <rect x="0" y="11.5" width="9.5" height="9.5" fill="#00a4ef" />
                <rect x="11.5" y="11.5" width="9.5" height="9.5" fill="#ffb900" />
              </svg>
              <span>Sign in with Microsoft</span>
            </button>
          </b-overlay>
        </div>
        <p class="login__content__form--footer">© 2022 Developed by guane Enterprises</p>
      </div>
    </div>
  </div>
</template>

<script>
import Repository from "../../services/repositories/repositoryFactory";

const AuthRepository = Repository.service("auth");

export default {
  name: "Login",
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    login() {
      this.isLoading = true;
      // Full-page redirect: backend -> Microsoft -> backend -> /auth/callback
      window.location.assign(AuthRepository.loginUrl());
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  position: relative;
  min-height: $view-height;
  background-image: url("../../assets/images/login.jpg");
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;

  &::before {
    content: "";
    position: absolute;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    background-color: rgba(0, 0, 0, 0.425);
  }

  &__information {
    display: flex;
    position: fixed;
    flex-direction: column;
    color: $color-white;
    margin: 10% 0 0 6%;
    text-align: initial;
    &__row {
      display: flex;
    }
    h1 {
      font-size: 60px;
      margin: 0;
    }
  }
  &__content {
    display: flex;
    justify-content: flex-end;
    position: relative;

    &__form {
      width: 30%;
      height: $view-height;
      padding: 4rem 3rem 0rem;
      background-color: $color-background-darker;
      position: relative;
      &--logo {
        width: 50%;
      }

      &__submit {
        padding: 20px 0px;
        &--hint {
          color: $color-white;
          margin: 0;
          text-align: center;
        }
        &__input-group {
          margin-bottom: 1rem;
          span {
            background-color: $color-submit-button;
            border-color: $color-submit-button;
            color: $color-black;
            border-top-left-radius: 8px;
            border-bottom-left-radius: 8px;
          }
          &--input {
            border-top-right-radius: 8px !important;
            border-bottom-right-radius: 8px !important;
          }
        }
        &__options {
          display: flex;
          justify-content: center;
          margin: $margin-most-used 0px;
        }
      }
      &--footer {
        position: absolute;
        bottom: 8px;
        left: 14%;
      }
    }
  }
}

@media (max-width: 1225px) {
  .login__content__form {
    width: 40%;
  }
}
@media (max-width: 960px) {
  .login {
    &__information {
      width: 55%;
      &__row {
        flex-wrap: wrap;
      }
      h1 {
        font-size: 4rem;
      }
      img {
        width: 6rem;
      }
    }
  }
}

@media (max-width: 750px) {
  .login {
    &__information {
      display: none;
    }
    &__content {
      justify-content: center;
      align-items: center;
      height: $view-height;
      &__form {
        width: 80%;
        height: auto;
        border-radius: 0.25rem;
        padding: 2rem 2rem;
      }
    }
  }
}

// Microsoft sign-in button, following their branding guidelines:
// white background, 1px #8c8c8c border, square corners, Segoe UI 15px
.ms-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  height: 41px;
  min-width: 250px;
  padding: 0 12px;
  background-color: #ffffff;
  border: 1px solid #8c8c8c;
  border-radius: 0;
  cursor: pointer;
  font-family: "Segoe UI", "Segoe UI Web (West European)", -apple-system,
    BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif;
  font-size: 15px;
  color: #5e5e5e;

  &__logo {
    width: 21px;
    height: 21px;
    flex-shrink: 0;
  }

  &:hover:not(:disabled) {
    background-color: #f3f3f3;
  }

  &:focus-visible {
    outline: 2px solid #2f2f2f;
    outline-offset: 1px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }
}
</style>
